import React from "react";
import { useIsMobile } from "../hooks/use-is-mobile";
import { cn } from "../lib/utils";

interface TabButtonProps {
  label: string;
  count?: number;
  active: boolean;
  onClick: () => void;
}

const MobileTabChip: React.FC<TabButtonProps> = ({ label, count, active, onClick }) => (
  <button
    type="button"
    role="tab"
    aria-selected={active}
    onClick={onClick}
    className={cn(
      "flex h-9 shrink-0 snap-start items-center gap-1.5 rounded-full border-0 px-4 text-[13px] transition-colors [-webkit-tap-highlight-color:transparent] active:scale-[0.97]",
      active
        ? "bg-gray-900 font-semibold text-white"
        : "bg-white font-medium text-gray-600 ring-1 ring-gray-200",
    )}
  >
    {label}
    {count !== undefined && (
      <span
        className={cn(
          "rounded-full px-1.5 text-[11px] leading-[18px]",
          active ? "bg-white/20 text-white" : "bg-gray-100 text-gray-500",
        )}
      >
        {count.toLocaleString()}
      </span>
    )}
  </button>
);

const TabButton: React.FC<TabButtonProps> = (props) => {
  const isMobile = useIsMobile();
  if (isMobile) return <MobileTabChip {...props} />;

  const { label, count, active, onClick } = props;
  return (
    <button
      className={`px-4 py-2 text-sm font-medium transition-colors duration-200 rounded-lg ${active
        ? "text-primary-600 bg-primary-50"
        : "text-gray-500 hover:text-gray-700 hover:bg-gray-100 bg-gray-50"
        }`}
      onClick={onClick}
    >
      {label}
      <span className="ml-2 text-xs text-gray-400">{count}</span>
    </button>
  );
};

export type { TabButtonProps };
export default TabButton;
